export type NotFoundError = Error;

export const isNotFound = (err: Error): err is NotFoundError => err.message === 'No Record';

export type AlreadyJoinError = Error;

export const isAlreadyJoinError = (err: Error): err is AlreadyJoinError =>
    err.message === '別端末で入室中のため入室できませんでした' ||
    err.message === 'Already in the channel with other device';

export type LockError = Error;

export const isLockError = (err: Error): err is LockError => {
    return err.message === 'Locked' || err.message === 'ロックされています';
};

export type ForbiddenError = Error;

export const isForbiddenError = (err: Error): err is ForbiddenError => err.message === 'forbidden access this resource';

// https://agoraio-community.github.io/AgoraWebSDK-NG/api/en/#typed-modules-for-typescript
// AgoraRTCErrorCode and ArgoRTCError is also defined in rcs-dsk_en.d.ts. However, they can't be exported

enum AgoraRTCErrorCode {
    PERMISSION_DENIED = 'PERMISSION_DENIED',
    INVALID_REMOTE_USER = 'INVALID_REMOTE_USER',
    REMOTE_USER_IS_NOT_PUBLISHED = 'REMOTE_USER_IS_NOT_PUBLISHED',
}

type AgoraRTCError = Error & {
    readonly data?: any;
    readonly code: AgoraRTCErrorCode;
    readonly message: string;
};

export type AgoraPermissionError = AgoraRTCError;

export const isAgoraPermissionError = (err: AgoraRTCError): err is AgoraPermissionError =>
    err.code === AgoraRTCErrorCode.PERMISSION_DENIED;

export type AgoraInvalidRemoteUserError = AgoraRTCError;

export const isAgoraInvalidRemoteUserError = (err: AgoraRTCError): err is AgoraInvalidRemoteUserError =>
    err.code === AgoraRTCErrorCode.INVALID_REMOTE_USER;

export type AgoraRemoteUserIsNotPublishedError = AgoraRTCError;

export const isAgoraRemoteUserIsNotPublishedError = (err: AgoraRTCError): err is AgoraRemoteUserIsNotPublishedError =>
    err.code === AgoraRTCErrorCode.REMOTE_USER_IS_NOT_PUBLISHED;
